import { render } from "./AddBankAccount.vue?vue&type=template&id=2803b5f4&scoped=true"
import script from "./AddBankAccount.vue?vue&type=script&lang=js"
export * from "./AddBankAccount.vue?vue&type=script&lang=js"

import "./AddBankAccount.vue?vue&type=style&index=0&id=2803b5f4&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2803b5f4"]])

export default __exports__